import React, { useEffect, useRef, useState } from "react";

//Importar helper para formatear la fecha.
import { formatHourAlt } from "../../../../../helpers/date"; 
import useScrollToBottom from "../../../../../hooks/useScrollToBottom";
import BtnScrollBottom from "../../../../common/Buttons/BtnScrollBottom";
import MessageByTypeInChat from "./MessageByTypeInChat";
import OperatorUserAvatar from "../../../../common/Avatar/OperatorUserAvatar";
import SessionDurationInfo from "../Sessions/SessionDurationInfo";
import { TransitionGroup } from 'react-transition-group';
import Collapse from '@mui/material/Collapse';

// MessageInChat: Componente que renderiza las burbujas con el mensaje dentro del chat de la sesión abierta
// (con los diferentes tipos de mensajes), ya sean mensajes salientes o entrantes.

const MessageInChat = ({ session, chatData }) => {

    const containerRef = useRef(null); //Crear la referencia para el contenedor de los mensajes.
    const [showScrollButton, setShowScrollButton] = useState(false);

    //Se ejecuta al renderizar el componente para scrollear al final del contenedor del mensaje.
    useScrollToBottom(containerRef, session);

    useEffect(() => { //Funcion para manejar el ocultar y mostrar el boton de scroll.
        const handleScroll = () => {
            if (containerRef !== null) { // Verificar si containerRef.current no es nulo
                const scrollPosition = containerRef.current.scrollHeight; //La posicion inicial del scroll al final inferior del contenedor (serian 12.595 px).
                if (scrollPosition < containerRef.current.scrollTop + 718) { //Si esa posicion inicial del scroll es menor que la posicion medida desde el top del contenedor mas la diferencia (12.077px + 818px)
                    //Cuando se vaya scrolleando la posicion del "containerRef.current.scrollTop" ira disminuyendo, por tanto esta condicion dejara de aplicarse y pasara a mostrar el boton.
                    setShowScrollButton(false); //Poner el boton oculto ya que aun no se scrolleo.
                }
                else { // Si ya se scrolleo un aproximado de 100px.
                    setShowScrollButton(true); //Mostrar el boton.
                }
            }
        };
        if (containerRef !== null) {
            containerRef.current.addEventListener("scroll", handleScroll);
        }
    }, []);

    return (
        <div className="container-messages" ref={containerRef} key={session.IdSession}>

            {/*--Información de la duración de la sesión-- */}
            <SessionDurationInfo />

            <div className="container-messages-with-hour">
                <TransitionGroup>
                    {session.Messages.map(mensaje => (
                        <Collapse key={mensaje.IdMessage} timeout={{ enter: 600, exit: 1000 }}>
                            <div key={mensaje.IdMessage} className={`container-width-message ${mensaje.Entrante ? "entrante" : "saliente"}`}>

                                {/*-----Contenedor del mensaje con la hora-------*/}
                                <div className="container-inline-message-with-hour">

                                    <div className={`container-message-profile-wiht-text ${mensaje.Entrante ? "entrante" : "saliente"}`}>

                                        <div
                                            className={`container-inline-message-with-hour ${mensaje.Type === "image" ? "image" : ""}`}>
                                            {/*---Renderizar el mensaje según si tipo-- */}
                                            <MessageByTypeInChat mensaje={mensaje} />

                                            {/*-----Renderiza la hora del mensaje-------*/}
                                            {mensaje.Entrante
                                                ? <label className="hour-message entrante" >{formatHourAlt(mensaje.FechaHora)}</label>
                                                : <label className="hour-message saliente">
                                                    <div className="container-userAvatar__in_message">
                                                        {/*--Renderizar el avatar del perfil del operador--*/}
                                                        {!mensaje.Entrante && <OperatorUserAvatar iniciales={mensaje.Iniciales} />}
                                                    </div>
                                                    {formatHourAlt(mensaje.FechaHora)}

                                                </label>
                                            }
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </Collapse>
                    )
                    )}
                </TransitionGroup>
            </div>

            {/* showScrollButton && <BtnScrollBottom containerRef={containerRef} /> */}

        </div>
    )
};

export default MessageInChat;